import Vue from 'vue'
import VueRouter from 'vue-router'
import config from "@/config"
import custom from "@/settings/custom"
//
import Home from '../views/Home.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    component: () => import("../layouts/default.vue"),
    children: [
      {
        path: '/error/:code',
        component: () => import("../views/errors/with_code.vue")
      },
      ...custom,
      {
        path: '/',
        name: 'Home',
        component: () => import("../views/Home.vue")
      },
      {
        path: '/v2/quickinfo',
        name: 'quickinfo',
        component: () => import("../views/Home2.vue")
      },
      {
        path: "/user/profile",
        name: "user_profile",
        component: () => import("../views/user/Profile.vue")
      },
      {
        path: "/:key",
        name: "List",
        component: () => import("../views/crud/List.vue")
      },
      {
        path: "/:key/create",
        name: "Create",
        component: () => import("../views/crud/Create.vue")
      },
      {
        path: "/:key/:search/search",
        name: "List",
        component: () => import("../views/crud/List.vue")
      },
      {
        path: "/:key/:id/edit",
        name: "Edit",
        component: () => import("../views/crud/Edit.vue")
      },
      {
        path: "/:key/:id/EditView",
        name: "EditView",
        component: () => import("../views/crud/EditView.vue")
      },
      {
        path: "/:key/:id",
        name: "View",
        component: () => import("../views/crud/View.vue")
      },
    ]
  },
  {
    path: '/login',
    component: () => import("../layouts/plain.vue"),
    children: [
      {
        path: '',
        name: 'Login',
        component: () => import("../views/user/Login.vue"),
      }
    ]
  },
  {
    path: '/public/trans/:cp',
    component: () => import("../layouts/plain.vue"),
    children: [
      {
        path: '',
        name: 'Login',
        component: () => import("../views/custom/trans.vue"),
      }
    ]
  },
];

const router = new VueRouter({
  mode: 'history',
  base: config.NAMESPACE,
  routes
});

router.beforeEach((to, from, next) => {
  // no token found means not logged in
  // force user to login first
  if(typeof localStorage.lt == "undefined" && to.name != "Login") {
    next({ name: "Login" })
  }else {
    next();
  }
  console.log("after beforeEach")
})

export default router
